import attribs from '../../settings/references.json'

export const attributes = {
    displaySeconds: attribs.ads.displaySeconds,
    steamOrigin: attribs.launcher.origin.steam,
    defaultOrigin: attribs.launcher.origin.default,
    url: attribs.service.adGlare,
    fallbackSource: attribs.ads.fallback.image_url,
    fallbackLink: attribs.ads.fallback.click_url,
}

export { launcherOpenUrl } from '../../launcherBackend/launcher-command'



// WEBPACK FOOTER //
// ./src/features/Ads/imports.js